module.exports = __webpack_public_path__ + "static/02-b1df0e9fad6879d2b923e5c4fc82f588.jpg";